import { Component, Input, OnInit } from '@angular/core';
import { Customer } from 'gung-standard';
import { JeevesCustomerDeliveryLocationListConfigService } from '../../services/jeeves-customer-delivery-location-list-config/jeeves-customer-delivery-location-list-config.service';

@Component({
  selector: 'gung-jeeves-jeeves-customer-details-delivery-location-list',
  templateUrl: './jeeves-customer-details-delivery-location-list.component.html',
  styleUrl: './jeeves-customer-details-delivery-location-list.component.css',
  standalone: false
})
export class JeevesCustomerDetailsDeliveryLocationListComponent implements OnInit {
  @Input() customer: Customer;

  constructor(
    public jeevesCustomerDeliveryLocationListConfigService: JeevesCustomerDeliveryLocationListConfigService
  ) {}

  ngOnInit(): void {
    this.jeevesCustomerDeliveryLocationListConfigService.customerId = this.customer?.id;
  }
}
